import i18next from 'i18next';
import React from 'react';

import { Input } from '@lib/inpulse/Input';

import { FieldLabel, InputFieldWrapper, RequiredStar, ErrorText } from '../styledComponents';

export const GeneratePublicApiFormActionFormInput = ({ errors, register }) => (
  <>
    <FieldLabel htmlFor="userName">
      <RequiredStar>*</RequiredStar>
      {i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.KEY_NAME_LABEL')}
    </FieldLabel>
    <InputFieldWrapper>
      <Input
        {...register('userName')}
        error={Boolean(errors.userName)}
        id="userName"
        placeholder=""
        type="text"
      />
    </InputFieldWrapper>
    {errors.userName && <ErrorText>{errors.userName.message}</ErrorText>}
  </>
);
